<app-page-loader></app-page-loader>
<app-global-spinner></app-global-spinner>
<router-outlet></router-outlet>
